import { RenderableBase } from './renderable-base';

export class RenderableHidden extends RenderableBase<string> {
}
